<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/cZjDvF/tc-custom/9781453262009.jpg?1734695125681" alt="This image is the cover for the book Sparring with Hemingway"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sparring with Hemingway
      </h1>
      <p class="bookDescription body article font2">
        <b>Schulberg goes toe to toe with his lifelong passion in this collection of his greatest writings on boxing</b><br/>“As much as I love boxing, I hate it.” So begins screenwriter, novelist, and journalist Budd Schulberg’s collection of essays on the sweet science of bruising, a sport that fueled his literary ambitions and unsettled his conscience from a young age. He gives riveting accounts of classic bouts, such as Rocky Marciano–Archie Moore, Muhammad Ali–George Foreman, and Marvin Hagler–Thomas Hearns. Yet these essays also offer insight into the sport’s sociological significance from a man who covered its highlights and corruption-marred lowlights for decades. <i>Sparring with Hemingway</i> stands as the unparalleled history of boxing’s place in American culture throughout the twentieth century. This ebook features an illustrated biography of Budd Schulberg including rare images and never-before-seen documents from the author’s estate.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Budd Schulberg
      </h2>
      
      <p class="authorDescription body article">Budd Schulberg (1914&ndash;2009) was a screenwriter, novelist, and journalist who is best remembered for the classic novels&#160;<I>What Makes Sammy Run?</I>,<I>&#160;The Harder They Fall</I>,and the story&#160;<I>On the Waterfront</I>, which he adapted as a novel, play, and an Academy Award&ndash;winning film script. Born in New York City, Schulberg grew up in Hollywood, where his father, B. P. Schulberg, was head of production at Paramount, among other studios. Throughout his career, Schulberg worked as a journalist and essayist, often writing about boxing, a lifelong passion. Many of his writings on the sport are collected in&#160;<I>Sparring with Hemingway&#160;</I>(1995). Other highlights from Schulberg&rsquo;s nonfiction career include&#160;<I>Moving Pictures</I>&#160;(1981), an account of his upbringing in Hollywood, and&#160;<I>Writers in America</I>&#160;(1973), a glimpse of some of the famous novelists he met early in his career. He died in 2009.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?416148de